import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetobhimashankartaxiservice() {



  const cardData = {
"keyword": "Pune to Bhimashankar Taxi Service",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Pune to Bhimashankar Taxi Service for devotees and nature lovers seeking safe, affordable, and convenient travel. Whether you are planning a temple darshan, pilgrimage tour, weekend trip, trekking adventure, or family outing, our taxi service ensures a smooth and stress-free journey through the scenic Sahyadri hills. With experienced drivers familiar with ghat routes, clean air-conditioned vehicles, and transparent pricing with no hidden charges, we provide a dependable travel experience from Pune to Bhimashankar. Our fleet includes sedans, SUVs, Innova cars, and premium vehicles suitable for solo travelers, families, and groups. With flexible one-way and round-trip options, doorstep pickup, easy cab booking, and 24/7 customer support, Shivai Travels ensures a comfortable and spiritual journey to one of the sacred Jyotirlinga temples.",

"topPlaces": [
  {
    "title": "Bhimashankar Jyotirlinga Temple",
    "description":
      "Bhimashankar Jyotirlinga Temple is one of the twelve sacred Jyotirlingas dedicated to Lord Shiva and a major pilgrimage destination in Maharashtra. Travelers using Pune to Bhimashankar taxi service visit this holy temple for darshan and blessings."
  },
  {
    "title": "Bhimashankar Wildlife Sanctuary",
    "description":
      "Bhimashankar Wildlife Sanctuary is a rich biodiversity zone known for rare flora, fauna, and the Indian Giant Squirrel. Cab travelers from Pune often explore this forest area during their visit."
  },
  {
    "title": "Hanuman Lake",
    "description":
      "Hanuman Lake is a peaceful natural water body near Bhimashankar surrounded by dense forests. Pune to Bhimashankar taxi service provides convenient access for nature lovers."
  },
  {
    "title": "Gupt Bhimashankar",
    "description":
      "Gupt Bhimashankar is a hidden spiritual site believed to be the original source of the Bhima River. Travelers booking Pune to Bhimashankar cabs often visit this sacred spot."
  },
  {
    "title": "Nagphani Point (Cobra’s Hood Viewpoint)",
    "description":
      "Nagphani Point is a scenic viewpoint shaped like a cobra’s hood offering breathtaking valley views. Cab from Pune ensures easy access for trekking and sightseeing."
  },
  {
    "title": "Sakshi Ganesh Temple",
    "description":
      "Sakshi Ganesh Temple is a small but important temple where devotees seek blessings before proceeding to Bhimashankar Jyotirlinga. Travelers from Pune often stop here en route."
  },
  {
    "title": "Shidi Ghat Trek Route",
    "description":
      "Shidi Ghat is a challenging trekking route with ladders and rocky patches leading to Bhimashankar. Pune to Bhimashankar taxi service is ideal for adventure travelers."
  },
  {
    "title": "Kondhwal Waterfall",
    "description":
      "Kondhwal Waterfall is a seasonal waterfall near Bhimashankar known for its scenic beauty during monsoon. Cab travelers from Pune enjoy visiting this natural attraction."
  },
  {
    "title": "Ahupe Ghat Viewpoint",
    "description":
      "Ahupe Ghat Viewpoint offers panoramic views of valleys, cliffs, and surrounding forests. Pune to Bhimashankar cab booking provides smooth access for nature photography."
  },
  {
    "title": "Bhimashankar Forest Trails",
    "description":
      "The forest trails around Bhimashankar are rich in wildlife and greenery, making them ideal for eco-tourism and trekking. Taxi service from Pune ensures a comfortable journey to these trails."
  }
],



services: [
  {
    name: "Pune to Bhimashankar Cab",
    description: "Pune to Bhimashankar cab service provides reliable transportation between Pune and Bhimashankar with comfortable vehicles and experienced drivers. Vehicles are suitable for highway and pilgrimage travel ensuring smooth and safe journeys for families, devotees, and tourists. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Bhimashankar. Vehicles include sedans, SUVs, Innova Crysta, Ertiga, and premium taxis suitable for different travel requirements. Flexible booking options allow convenient one-way and round-trip cab reservations."
  },
  {
    name: "Pune to Bhimashankar Taxi",
    description: "Pune to Bhimashankar taxi service offers dependable transportation for passengers traveling between Pune and Bhimashankar with professional chauffeurs and comfortable vehicles. Vehicles provide spacious seating and smooth highway travel suitable for temple visits, pilgrimage tours, and family journeys. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Bhimashankar. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Cab from Pune to Bhimashankar",
    description: "Cab from Pune to Bhimashankar service provides comfortable intercity transportation for passengers traveling for Jyotirlinga Darshan, tourism, and family trips. Vehicles ensure reliable highway and ghat travel with experienced chauffeurs offering safe and smooth journeys. Pickup services are available from residential areas, offices, hotels, railway stations, and airports across Pune and Bhimashankar. Ideal for one-way and round-trip travel requirements. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Taxi from Pune to Bhimashankar",
    description: "Taxi from Pune to Bhimashankar service offers reliable transportation with comfortable vehicles and professional drivers for travel between Pune and Bhimashankar. Vehicles provide smooth highway and hill route travel suitable for pilgrimage tours, sightseeing, and family trips. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Bhimashankar. Flexible booking options allow easy taxi reservations."
  },
  {
    name: "Pune to Bhimashankar Cab Service",
    description: "Pune to Bhimashankar cab service provides dependable transportation solutions for passengers traveling between Pune and Bhimashankar with comfortable vehicles and experienced chauffeurs. Vehicles are suitable for long-distance pilgrimage travel ensuring safe and smooth journeys for individuals, families, and group travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Bhimashankar. Ideal for Jyotirlinga temple visits and family trips. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Pune to Bhimashankar Taxi Fare",
    description: "Pune to Bhimashankar taxi fare service provides transparent pricing information for passengers planning travel between Pune and Bhimashankar. Travelers can estimate transportation costs based on vehicle type, travel distance, and trip requirements. Comfortable vehicles ensure smooth highway and ghat travel with professional drivers offering safe transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Bhimashankar. Flexible booking options allow convenient fare estimation and taxi reservations."
  },
  {
    name: "Pune to Bhimashankar One Way Cab",
    description: "Pune to Bhimashankar one way cab service provides economical transportation for passengers traveling from Pune to Bhimashankar without return travel requirements. Comfortable vehicles ensure smooth highway travel suitable for temple visits, family travel, and pilgrimage tours. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune and Bhimashankar including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient one-way cab reservations."
  },
  {
    name: "Pune to Bhimashankar Round Trip Taxi",
    description: "Pune to Bhimashankar round trip taxi service offers convenient return transportation for passengers planning travel between Pune and Bhimashankar. Comfortable vehicles provide smooth highway and ghat journeys with experienced drivers ensuring safe and reliable transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Bhimashankar. Ideal for pilgrimage tours, sightseeing, and family trips. Flexible booking options allow convenient round-trip taxi reservations."
  },
  {
    name: "Pune to Bhimashankar Cab Booking",
    description: "Pune to Bhimashankar cab booking service allows passengers to reserve comfortable transportation between Pune and Bhimashankar. Vehicles include sedans, SUVs, luxury cars, Innova Crysta, and premium taxis suitable for different passenger requirements. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Bhimashankar. Flexible booking options allow instant and advance cab reservations."
  },
  {
    name: "Cheap Pune to Bhimashankar Cab",
    description: "Cheap Pune to Bhimashankar cab service provides affordable transportation between Pune and Bhimashankar with comfortable vehicles and economical pricing. Vehicles ensure reliable highway travel suitable for pilgrimage tours, family journeys, and tourism. Professional drivers ensure safe driving and timely pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune and Bhimashankar. Flexible booking options allow convenient low-cost cab reservations."
  },
  {
    name: "Best Pune to Bhimashankar Taxi",
    description: "Best Pune to Bhimashankar taxi service offers premium transportation with comfortable vehicles and professional chauffeurs for smooth pilgrimage travel. Vehicles provide spacious seating, luggage capacity, and reliable highway performance suitable for temple visits, tourism, and family trips. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Bhimashankar. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Sedan Pune to Bhimashankar Cab",
    description: "Sedan Pune to Bhimashankar cab service offers economical and comfortable transportation for solo travelers, couples, and small families traveling between Pune and Bhimashankar. Sedan vehicles provide smooth highway and ghat travel with comfortable seating and luggage space suitable for pilgrimage journeys. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune and Bhimashankar. Flexible booking options allow convenient sedan cab reservations."
  },
  {
    name: "SUV Pune to Bhimashankar Taxi",
    description: "SUV Pune to Bhimashankar taxi service provides spacious transportation for families and groups traveling between Pune and Bhimashankar. SUV vehicles offer comfortable seating, luggage capacity, and smooth highway performance suitable for pilgrimage and family journeys. Professional chauffeurs ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Bhimashankar. Flexible booking options allow convenient SUV taxi reservations."
  },
  {
    name: "Innova Pune to Bhimashankar Cab",
    description: "Innova Pune to Bhimashankar cab service provides premium SUV transportation for passengers seeking comfortable and reliable pilgrimage travel. Innova vehicles offer spacious seating, smooth ride quality, and luggage space suitable for temple visits, sightseeing, and family trips. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune and Bhimashankar. Flexible booking options allow convenient Innova cab reservations."
  },
  {
    name: "Jyotirlinga Cab Pune Bhimashankar",
    description: "Jyotirlinga cab Pune Bhimashankar service offers dependable transportation for passengers traveling from Pune to Bhimashankar Jyotirlinga Temple. Comfortable vehicles ensure smooth highway and ghat travel suitable for temple visits, spiritual tours, and family pilgrimages. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune and Bhimashankar. Flexible booking options allow convenient Jyotirlinga cab reservations."
  }
],

tableData: [
  ["Pune to Bhimashankar Cab", "Pune to Bhimashankar Taxi"],
  ["Cab from Pune to Bhimashankar", "Taxi from Pune to Bhimashankar"],
  ["Pune to Bhimashankar Cab Service", "Pune to Bhimashankar Taxi Fare"],
  ["Pune to Bhimashankar One Way Cab", "Pune to Bhimashankar Round Trip Taxi"],
  ["Pune to Bhimashankar Cab Booking", "Cheap Pune to Bhimashankar Cab"],
  ["Best Pune to Bhimashankar Taxi", "Sedan Pune to Bhimashankar Cab"],
  ["SUV Pune to Bhimashankar Taxi", "Innova Pune to Bhimashankar Cab"],
  ["Jyotirlinga Cab Pune Bhimashankar", "Pune to Bhimashankar Cab Service"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Pune to Shirdi Cab Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune to Shirdi cab service with professional drivers, comfortable vehicles, and punctual pickup for smooth and safe pilgrimage travel."
      },
      {
        WhyChooseheading: "Affordable Pune to Shirdi Taxi Fare",
        WhyChoosedescription: "Shivai Travels offers affordable Pune to Shirdi cab pricing with transparent fare details and no hidden charges. Customers receive complete fare information before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 Shirdi Cab Availability",
        WhyChoosedescription: "Our Pune to Shirdi cab service operates 24 hours a day for Sai Baba darshan, family trips, temple visits, emergency transportation, and weekend travel requirements."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Cabs",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide comfortable travel experiences for passengers visiting Shirdi."
      },
      {
        WhyChooseheading: "One Way & Round Trip Cab Booking",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way Pune to Shirdi taxi service, round-trip bookings, Shirdi Darshan tours, and customized pilgrimage travel packages."
      },
      {
        WhyChooseheading: "Wide Range of Cab Vehicle Choices",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for pilgrims, families, tourists, and group tours."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, offices, hotels, Pune Airport, railway stations, and all major Pune areas including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Temple Travel",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune to Shirdi highway routes and ensure safe driving, smooth travel, and timely arrival for every pilgrimage journey."
      }
    ]
  };

 const faqData = [
  { question: "What is Pune to Bhimashankar taxi service?", answer: "Pune to Bhimashankar taxi service provides comfortable and safe travel from Pune to Bhimashankar Jyotirlinga temple for pilgrimage, sightseeing, and family trips." },
  { question: "Is Pune to Bhimashankar taxi service available 24 hours?", answer: "Yes, Shivai Travels offers 24/7 Pune to Bhimashankar taxi service for early morning darshan and flexible travel plans." },
  { question: "Which vehicles are available for Pune to Bhimashankar trip?", answer: "Shivai Travels provides sedan cars, Ertiga, Innova, Innova Crysta, and Tempo Traveller options for Bhimashankar travel." },
  { question: "Can I book a one-way taxi from Pune to Bhimashankar?", answer: "Yes, both one-way and round-trip Pune to Bhimashankar taxi services are available as per customer requirements." },
  { question: "Is Bhimashankar taxi suitable for family travel?", answer: "Yes, it is ideal for families and groups with safe, comfortable, and spacious vehicle options for hill travel." },
  { question: "Are Pune to Bhimashankar cabs safe for ghat roads?", answer: "Yes, experienced drivers from Shivai Travels ensure safe driving on ghat roads and hilly terrain to Bhimashankar." },
  { question: "How can I book Pune to Bhimashankar taxi service?", answer: "You can book Pune to Bhimashankar taxi service online or via phone booking with Shivai Travels." },
  { question: "Do you provide Bhimashankar pilgrimage packages?", answer: "Yes, customized pilgrimage packages including Bhimashankar darshan are available for solo and group travelers." },
  { question: "Are Pune to Bhimashankar taxi fares fixed?", answer: "Yes, Shivai Travels offers transparent and affordable fares with no hidden charges." },
  { question: "Is advance booking recommended for Bhimashankar taxi?", answer: "Yes, advance booking is recommended on weekends and religious days due to high demand." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sachin Jadhav",
    feedback:
      "Shivai Travels provided a safe and comfortable Pune to Bhimashankar taxi service with an experienced driver who handled the ghat roads very smoothly and professionally.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Aarti Kulkarni",
    feedback:
      "The Pune to Bhimashankar cab service was very reliable with timely pickup and a peaceful journey, making our temple visit convenient and stress-free.",
    rating: 5
  }
];





















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Bhimashankar Taxi Service",
  "image": "https://shivaitravels.com/assets/images/pune-to-bhimashankar-cab.jpg",
  "description": "Book Pune to Bhimashankar taxi service for safe and comfortable pilgrimage travel. Shivai Travels offers affordable one-way and round-trip cab booking with sedan, SUV, Innova, and luxury cab options available 24x7 for Jyotirlinga temple visits and religious trips.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹11/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-to-bhimashankar-cab"
  }
};







  return (
    <div>
<Helmet>
  <title>Pune to Bhimashankar Taxi Service | Jyotirlinga Cab Booking | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune to Bhimashankar taxi service for one-way and round trip travel. Affordable cab options including sedan, SUV, Innova, and luxury cabs available 24x7 for Jyotirlinga temple visits and pilgrimage trips."
  />

  <meta
    name="keywords"
    content="pune to bhimashankar cab, pune to bhimashankar taxi, cab from pune to bhimashankar, taxi from pune to bhimashankar, pune to bhimashankar cab service, pune to bhimashankar taxi fare, pune to bhimashankar one way cab, pune to bhimashankar round trip taxi, pune to bhimashankar cab booking, cheap pune to bhimashankar cab, best pune to bhimashankar taxi, sedan pune to bhimashankar cab, suv pune to bhimashankar taxi, innova pune to bhimashankar cab, jyotirlinga cab pune bhimashankar"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/44.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetobhimashankartaxiservice;